//SliderSlick

//Appel autres fichiers
/*var $ = require('jquery');
window.$ = $;

require('./slick.min.js');

$.noConflict();*/

$('.carousel.reponses').slick({
    centerMode: false,
    dots: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 300,
    centerPadding: '60px',
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    pauseOnFocus: true,
    appendDots: $(".slick-dots"),
    prevArrow: $(".prev-arrow"),
    nextArrow: $(".next-arrow"),
    lazyLoad: 'progressive',
})
.on('setPosition', function (event, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
});
